import React from "react";
import { BackgroundImage, ServiceBottomButton, TeethLogo } from "../../Components"
import dental_implants from "../../assets/Images/dental-implants-home.jpg"

const DentalImplants = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.txt_dental_implants} text={selectedLanguage?.txt_explore_our_services} mainClass='dental-implants-background' />
            <TeethLogo heading='DENTAL IMPLANTS' />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={dental_implants} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.txt_dental_science_are_undergoing_massive}</p>
                    <p>{selectedLanguage?.txt_with_today_advancements_in_dental_implant_and_bone_grafting}</p>
                    <p>{selectedLanguage?.txt_in_our_clinic_dental_implants_include}</p>
                    <ul>
                        <li>{selectedLanguage?.txt_conventional_implants}</li>
                        <li>{selectedLanguage?.txt_single_implants}</li>
                        <li>{selectedLanguage?.txt_full_arch_implant_bridge}</li>
                    </ul>
                    <p>{selectedLanguage?.txt_why_primadent_dental_center_for_dental}</p>
                    <ul>
                        <li>{selectedLanguage?.txt_all_our_implantologists_are_experienced}</li>
                        <li>{selectedLanguage?.txt_all_our_dental_implants_cases_are_looked}</li>
                        <li>{selectedLanguage?.txt_our_clinic_and_team_of_dental_specialists}</li>
                        <li>{selectedLanguage?.txt_a_holistic_approach_is_taken}</li>
                        <li>{selectedLanguage?.txt_primadent_is_a_leading_dental_implant_center} </li>
                        <li>{selectedLanguage?.txt_all_our_treatment_plans_and_services}</li>
                    </ul>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default DentalImplants